import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../core/auth.service';
import { ReadinessService } from '../core/readiness.service';
import { translate as t } from '../core/i18n';

@Component({
  selector: 'app-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss'],
  standalone: false,
})
export class ServiceUnavailableComponent implements OnDestroy {
  checking = false;
  message = '';
  private retrySub?: Subscription;

  constructor(
    private readiness: ReadinessService,
    private auth: AuthService,
    private router: Router
  ) {}

  retry(): void {
    if (this.checking) {
      return;
    }

    this.message = '';
    this.checking = true;
    this.retrySub?.unsubscribe();
    this.retrySub = this.readiness.checkReadiness().subscribe({
      next: (ready) => {
        if (!ready) {
          this.checking = false;
          this.message = t(
            'ui.service.unavailable.service.unavailable.component.text.el_servicio_aun_no_esta_listo_intentalo_de_nuevo_en',
            undefined,
            'El servicio aun no esta listo. Inténtalo de nuevo en unos segundos.'
          );
          return;
        }

        this.auth.ensureSession().subscribe({
          next: (hasSession) => {
            this.checking = false;
            this.router.navigateByUrl(hasSession ? '/scores' : '/login', {
              replaceUrl: true,
            });
          },
          error: () => {
            this.checking = false;
            this.router.navigateByUrl('/login', { replaceUrl: true });
          },
        });
      },
      error: () => {
        this.checking = false;
        this.message = t(
          'ui.service.unavailable.service.unavailable.component.text.no_se_pudo_verificar_el_estado_del_servicio',
          undefined,
          'No pudimos comprobarlo. Intenta otra vez.'
        );
      },
    });
  }

  ngOnDestroy(): void {
    this.retrySub?.unsubscribe();
  }
}
